import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from '@mui/material';
import { GuiMessage } from '../../types/GuiMessage';

interface GuiMessageModalProps {
    message: GuiMessage | null;
    onAccept: (id: number) => void;
}

const GuiMessageModal: React.FC<GuiMessageModalProps> = ({ message, onAccept }) => {
    if (!message) return null;

    return (
        <Dialog
            open={!!message}
            onClose={() => {}} // Zablokowanie zamykania przez kliknięcie poza
            maxWidth="md"
            fullWidth
            disableEscapeKeyDown
        >
            <DialogTitle>
                Powiadomienie
            </DialogTitle>
            <DialogContent dividers>
                <Box
                    sx={{
                        '& img': { maxWidth: '100%', height: 'auto' },
                        '& table': { borderCollapse: 'collapse', width: '100%' },
                        '& th, & td': { border: '1px solid #ddd', padding: '8px' }
                    }}
                    dangerouslySetInnerHTML={{ __html: message.content }}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => onAccept(message.id)}
                    variant="contained"
                    color="primary"
                    fullWidth
                >
                    Rozumiem / Akceptuję
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default GuiMessageModal;
